import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { FiTarget } from 'react-icons/fi';

// Custom components
import React, { useEffect, useState } from 'react';
import qrCode from 'assets/img/qrcode.png';
import { Button } from 'react-bootstrap';
import { IoMdAdd } from 'react-icons/io';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import ReactPaginate from 'react-paginate';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { allAppointmentDetail, allProblemDetail, appointementGet, appointementGetById, countAppointment, searchAllAppointmentDetail } from '../../../redux/actions/Files.action';
import { IoSearchOutline } from 'react-icons/io5';
import { appointmentAllCount } from '../../../redux/actions/Admin.action';
import { getDoctorAppointment } from '../../../redux/actions/Doctor.action';
import AppoinmentView from 'views/admin/addAppointment/AppoinmentView';
import { RiRestartLine } from 'react-icons/ri';
import Select from 'react-select';
import { debounce } from 'lodash';

const DailyTreatment = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [options, setOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    page: '',
    search: '',
  });

  const limits = {
    page: mainPage,
    limit: rowsPerPage
  }

  const appointementCount = useSelector((state) => state.admin)
  const appointement = useSelector((state) => state.files)
  const doctorData = useSelector((state) => state.doctor)

  const [currentDate, setCurrentDate] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [selectedType, setSelectedType] = useState('');

  useEffect(() => {
    const today = new Date();
    const formattedDate = today.toISOString().split('T')[0];
    setCurrentDate(formattedDate);
  }, []);


  const toggle = () => {
    setShow(!show);
  };

  const viewToggle = () => {
    setViewModal(!viewModal);
  };

  const handleAppointment = (id) => {
    dispatch(appointementGetById(id))
  }

  const today = new Date();

  useEffect(() => {
    if (location.state?.showModal) {
      setShow(true);
    }
  }, [location.state]);

  // const ChangeMainPage = (selected) => {
  //   setMainPage(parseInt(selected.selected) + 1);
  // };

  const ChangeMainPage = (selected) => {
    const newPage = parseInt(selected.selected) + 1;
    setMainPage(newPage);

    const updatedSearchParams = {
      ...searchDefault,
      search: searchQuery,
      page: newPage,
      limit: rowsPerPage,
    };

    setSearchDefault(updatedSearchParams);

    // If a search query is present, call search with the updated page
    if (searchQuery) {
      dispatch(getDoctorAppointment(limits, selectedDate, searchQuery, selectedOption?.value || ""));
    } else {
      // Call the API to fetch data based on date and type with the new page
      dispatch(allAppointmentDetail(limits, selectedDate, selectedType));
    }
  };


  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    doctorData?.getDoctorAppointment?.data?.totalCount / postPerPage,
  );

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleTypeChange = (e) => {
    setSelectedType(e.target.value)
  }

  const handleSearch = debounce((e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);

    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || '',
      page: mainPage,
      limit: rowsPerPage,
    };

    setSearchDefault(newSearchParams);

    dispatch(getDoctorAppointment(limits, selectedDate, newSearchQuery, selectedOption?.value || ""));
}, 300);
  const getStatusColor = (status) => {
    if (status === 'confirm') {
      return '#E9FEF5';
    } else if (status === 'pending') {
      return '#ffffcc';
    }
  };

  useEffect(() => {
    dispatch(getDoctorAppointment(limits, selectedDate, searchQuery, selectedOption?.value || ""));
    dispatch(allProblemDetail())
  }, [mainPage, currentDate, rowsPerPage, selectedDate, selectedType]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const sortedAppointments = [...(doctorData?.getDoctorAppointment?.data?.appointments || [])].sort((a, b) => {
    const dateA = new Date(a.dateOfAppointment);
    const dateB = new Date(b.dateOfAppointment);

    // Sort by date first
    if (dateA - dateB !== 0) {
      return dateA - dateB;
    }

    // Convert 12-hour format to 24-hour for sorting
    const convertTo24Hour = (time) => {
      if (!time) return 0;
      const [hours, minutes, period] = time.match(/(\d+):(\d+) (\w+)/).slice(1);
      let hour = parseInt(hours, 10);
      const minute = parseInt(minutes, 10);

      if (period.toLowerCase() === "pm" && hour !== 12) {
        hour += 12;
      } else if (period.toLowerCase() === "am" && hour === 12) {
        hour = 0;
      }

      return hour * 60 + minute; // Convert time to minutes
    };

    return convertTo24Hour(a.time) - convertTo24Hour(b.time);
  });

  useEffect(() => {
    if (appointement?.allProblem?.data?.Problem) {
      const formattedOptions = appointement.allProblem.data.Problem.map((problem) => ({
        value: problem.problem,
        label: problem.problem
      }));
      setOptions(formattedOptions);
      console.log('formattedOptions', formattedOptions);

    }
  }, [appointement]);

  useEffect(() => {
    const newSearchParams = {
      ...searchDefault,
      search: searchQuery || '',
      page: 1,
      limit: rowsPerPage,
      date: currentDate
    };
    setSearchDefault(newSearchParams);
    setMainPage(1);
    if (selectedOption) {
      dispatch(getDoctorAppointment(limits, selectedDate, searchQuery, selectedOption?.value || ""));
    }
  }, [selectedOption])

  const handleReset = () => {
    setSelectedOption('')
    dispatch(getDoctorAppointment(limits, selectedDate, searchQuery, ""));
  }

  return (
    <>
      <div className="mt-[100px] d-flex justify-between">
        <div className="d-lg-flex gap-2">
          <div className='w-[200px]'>
            <label className="text-sm block mb-1">Date</label>
            <input
              type="date"
              name="date"
              value={selectedDate}
              onChange={handleDateChange}
              className="w-75 outline-none !border-b"
            />
          </div>
          {/* <div>
            <label className="text-sm block mb-1">Filter</label>
            <select name="" id="" value={selectedType} onChange={handleTypeChange} className='w-full border-b outline-none'>
              <option value="">Select option</option>
              <option value="Confirm">Confirm</option>
              <option value="Pending">Pending</option>
            </select>
          </div> */}
        </div>
        <div className="d-flex items-center">
          <div className='flex  item-center me-3'>
            <div className='flex gap-2 !text-gray-600 px-3  border-r-2 !border-[gray]'>
              <h5>Total :</h5>
              <h5 className='border-b-2 !border-[gray] '>{doctorData?.getDoctorAppointment?.data?.totalCount}</h5>
            </div>
            <div className='flex gap-2 px-3 text-success border-r-2 !border-[gray]'>
              <h5 className=''>Confirm :</h5>
              <h5 className='border-b-2  !border-[gray] '>{doctorData?.getDoctorAppointment?.data?.confirmCount}</h5>
            </div>
            <div className='flex gap-2 text-warning px-3 '>
              <h5>Panding :</h5>
              <h5 className='border-b-2 !border-[gray] '>{doctorData?.getDoctorAppointment?.data?.pendingCount}</h5>
            </div>
          </div>
          <div>
            <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2">
              <IoSearchOutline />
              <input
                type="text"
                name="searchQuery"
                defaultValue={searchQuery}
                onChange={handleSearch}
                className="w-full outline-none"
                placeholder="Search..."
              />
            </div>
          </div>
        </div>
      </div>
      <div className='flex items-center justify-between mt-5'>
        <div>
          <label className="text-sm block mb-1">Consult</label>
          <div className='flex items-center gap-2'>
            <Select className='w-[250px] me-auto focus:!outline-none'
              value={selectedOption}
              onChange={setSelectedOption}
              options={options}
            />
            <RiRestartLine size={20} className='cursor-pointer' onClick={handleReset} />
          </div>
        </div>
        <div>
          Rows per page:
          <select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="ms-2 border rounded-md focus:outline-none"
          >
            <option value={10}>10</option>
            <option value={30}>30</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
          </select>
        </div>
      </div>
      <div className="mt-[30px] mb-3">
        <TableContainer>
          <Table
            className='!border-2'
            cellPadding="10"
            style={{ width: "100%", textAlign: "left", borderCollapse: "collapse" }}
          >
            <Thead className='!border-2 !border-[#e5e7eb]'>
              <Tr>
                <Th style={{ width: '100px' }} className='!border-r-2 !border-[#e5e7eb]'>Date</Th>
                <Th style={{ width: '100px' }} className='!border-r-2 !border-[#e5e7eb]'>Time</Th>
                {/* <Th colSpan={6} className='text-center'>
                  <input type='date' value={currentDate} className='border-0 outline-none' onChange={(e) => setCurrentDate(e.target.value)} />
                </Th> */}
              </Tr>
            </Thead>
            <Tbody >
              {
                sortedAppointments?.map((res, index) => {
                  return (
                    <Tr key={index}>
                      <Td style={{ backgroundColor: "#f0f0f0", padding: "10px", border: "1px solid #ccc", }} className='!border-[#b3b4b5]'> {res?.dateOfAppointment ? formatDate(res.dateOfAppointment) : ''}</Td>
                      <Td style={{ backgroundColor: "#f0f0f0", padding: "10px" }} className='!border-[#b3b4b5]'>
                        {res?.time}
                      </Td>
                      <Td onClick={() => { viewToggle(); handleAppointment(res._id) }} style={{
                        backgroundColor: getStatusColor(res.status),
                        padding: "10px",
                        cursor: "pointer",
                        margin: "5px",
                        border: "1px solid #ccc",
                        textAlign: "center",
                      }}>
                        <span className='capitalize'>{res.firstName} {res.lastName}</span> ({res.phoneNumber}) - {res.issue} - ({res.billingLabel})
                      </Td>
                    </Tr>
                  )
                })
              }
            </Tbody>
          </Table>
        </TableContainer>
      </div>

      <ReactPaginate
        breakLabel="..."
        nextLabel="next >"
        onPageChange={ChangeMainPage}
        pageRangeDisplayed={5}
        pageCount={PageCount}
        previousLabel="< previous"
        renderOnZeroPageCount={null}
        className="pagination"
      />
      <AppoinmentView viewModal={viewModal} setViewModal={setViewModal} viewToggle={viewToggle} limits={limits} />
    </>
  );
};

export default DailyTreatment;
